import { Navigate } from 'react-router-dom';

export default function AdminReconciliation() {
  return <Navigate to="/admin/reconciliation-monitor" replace />;
}